@if (faq()) {
  <h2 class="text-2xl font-bold mb-5">{{ faq().category }}</h2>

  <div class="flex flex-col gap-4">
    @for (item of faq().questions; track item.question) {
      <div class="flex flex-col gap-1">
        <div class="font-bold">{{ item.question }}</div>
        <div class="text-base">{{ item.answer }}</div>
      </div>
    }
  </div>
}
